<template lang="pug">
.sell-list
  GenericCard.productList(size='85' :ignoreMaxWidth='true')
    .sticky-top.bg-white
      .d-flex.align-items-end.px-4.py-4
        .d-flex
          CustomAreaFilter(
            title='เลือกดูตามเขต'
            v-model='filterArea'
          )
          CustomCategoriesFilter.ml-4(
            title='เลือกดูตามสถานะ'
            :items='statusList'
            v-model='filterStatus'
          )
        PanelTitleRight.ml-auto(
          title='รายการขาย'
          :subtitle='tableData ? `${totalRows} รายการ`:`...`'
          v-model='filterDate'
        )
      .w-100.px-4.py-2
        CustomSearchBox.ml-auto(
          v-model='filterSearch'
          type='text' placeholder='ค้นหาด้วยเลขที่รายการ'
          width='100%'
          :isLoading='isLoading'
        )
          i.fa.fa-search

      hr.mb-0

    LoadedContentWrapper(
      :isLoading='isLoading'
      :data='tableData'
      @reload='loadData'
    )
      .py-2.px-3.scrollable.h-scrollable
        CustomTable.w-max-content(
          :columns='tableColumns'
          :data='filteredTableData'
          :showIndexes='true'
          :showNotificationDots='true'
          :startIndex='pageFirstRowIndex'
          @itemClicked='showModal'
        )
      .sticky-bottom.bg-white
        hr.m-0
        .px-4.py-3
          CustomPagination(
            v-model='currentPage'
            :total='totalPage'
          )
  modal(
    name='sell-record'
    width='90%' height='95%'
    transition='modal-transition'
  )
    CSSellRecordDetail(
      :sellRecord='selectedItem'
      :customer='selectedItem'
      @closeButtonClicked='hideModal'
    )

</template>

<script>
/* eslint-disable arrow-body-style */
import CSSellRecordDetail from '@/components/_cs/sell-records/dialogs/SellRecord/CSSellRecordDetail.vue';

export default {
  props: {
    preSelectedOrder: {},
  },
  watch: {
    // reload data
    filterDate: {
      deep: true,
      handler() { this.currentPage = 1; this.loadData(); },
    },
    filterArea() { this.currentPage = 1; this.loadData(); },
    filterSearch() { this.currentPage = 1; this.loadData(); },
    filterStatus() { this.currentPage = 1; this.loadData(); },
    currentPage() { this.loadData(); },
  },
  computed: {
    filteredTableData() {
      // const KEYWORD = this.filterSearch.trim().toUpperCase();
      // return this.tableData.filter((item) => {
      //   return (
      //     // (this.filterDate === '' || this.$dateUtils.isInRange(item.date, this.filterDate))
      //     (!this.filterStatus || item.status.toString() === this.filterStatus)
      //     && (!KEYWORD
      //       || (item.entryNo && item.entryNo.toUpperCase().startsWith(KEYWORD))
      //       || (item.customer && item.customer.name
      //         && item.customer.name.toUpperCase().includes(KEYWORD))
      //       || (item.user && item.user.name
      //         && item.user.name.toUpperCase().includes(KEYWORD))
      //     )
      //   );
      // });
      return this.tableData;
    },
  },
  data() {
    return {
      isLoading: false,

      // statusList: this.$api.customer.ORDER_STATUS,
      statusList: {
        pending: 'รออนุมัติ',
        submitted: 'อนุมัติ',
        cancelled: 'ไม่อนุมัติ',
        unix: 'UNIX',
      },
      filterStatus: '',

      filterDate: '',
      filterSearch: '',
      filterArea: '',
      tableData: [],
      tableColumns: {
        date: {
          title: 'วันที่ทำรายการ',
          align: 'left',
          type: Date,
        },
        entryNo: {
          title: 'เลขที่',
          align: 'left',
          type: 'EntryNo',
        },
        zone: {
          title: 'เขต',
          align: 'center',
          computed: (row) => {
            if (row.customer) {
              return row.customer.zone;
            }
            return '-';
          },
        },
        customerName: {
          title: 'ชื่อลูกค้า',
          align: 'left',
          computed: (row) => {
            if (row.customer) {
              return row.customer.name;
            }
            return '-';
          },
        },
        weight: {
          title: 'น.น.',
          align: 'right',
          type: Number,
          computed: (row) => {
            if (row.products) {
              const totalWeight = row.products.reduce((prev, elm) => {
                return prev + Number(elm.product ? elm.product.weight : 0);
              }, 0);
              return totalWeight;
            }
            return '-';
          },
        },
        total: {
          title: 'ยอดรวม',
          align: 'right',
          type: Number,
          computed(row) {
            let total = 0;
            for (let i = 0; i < row.products.length; i += 1) {
              const PROD = row.products[i];
              total += Number(PROD.price);
            }
            return total;
          },
        },
        sellerName: {
          title: 'ผู้ขาย',
          align: 'right',
          computed: (row) => {
            if (row.user) {
              return row.user.name;
            }
            return '-';
          },
        },
        status: {
          title: 'สถานะ',
          align: 'center',
          type: this.$api.cs.customer.COL_TYPE.OrderStatus,
        },
        shipmentStatus: {
          title: 'สถานะจัดส่ง',
          align: 'center',
          type: this.$api.cs.customer.COL_TYPE.ShipmentStatus,
        },
      },

      currentPage: 1,
      totalPage: 0,
      totalRows: 0,
      pageFirstRowIndex: 1,

      selectedItem: {},
    };
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      // reset data
      this.tableData = null;

      try {
        const res = await this.$api.cs.sellRecord.sell(
          this.currentPage,
          this.filterDate.from,
          this.filterDate.to,
          this.filterSearch,
          this.filterStatus,
          this.filterArea,
        );
        if (res.status === 200) {
          this.tableData = res.data.data;
          this.currentPage = res.data.current_page;
          this.totalPage = res.data.last_page;
          this.totalRows = res.data.total;
          this.pageFirstRowIndex = res.data.from;
        }
      } catch (e) {
        this.tableData = null;
        this.pageFirstRowIndex = 1;
      }

      this.isLoading = false;
    },
    showModal(e) {
      this.selectedItem = e.data;
      this.$modal.show('sell-record');
    },
    hideModal() {
      // console.log('close');
      this.$modal.hide('sell-record');
      this.loadData();
    },
  },
  mounted() {
    // const id = this.customer ? this.customer.id : '';
    this.loadData();

    if (this.preSelectedOrder) {
      this.showModal({ data: this.preSelectedOrder });
    }
  },
  components: {
    CSSellRecordDetail,
  },
};
</script>

<style lang="scss">
// .sell-list {}
</style>
